export default __webpack_public_path__ + "static/img/Letinte13.37d7054.jpg";